import * as React from 'react';

export default function useToolboxOverflowState() {
    const [overflowTarget, setOverflowTarget] = React.useState<Element | undefined>();

    const onOverflowClick = React.useCallback(
        (ev?: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => {
            setOverflowTarget(ev?.currentTarget);
        },
        [setOverflowTarget]
    );

    const onOverflowDismiss = React.useCallback(() => {
        setOverflowTarget(undefined);
    }, [setOverflowTarget]);

    return {
        overflowTarget: overflowTarget,
        onOverflowClick: onOverflowClick,
        onOverflowDismiss: onOverflowDismiss,
    };
}
